import type { SocialCaptions } from 'bundles/sharing-common/types/sharingSharedTypes';

import _t from 'i18n!nls/xddp';

type GetSocialCaptionsArgs = {
  programName: string;
  partnerName: string;
};

export default ({ programName, partnerName }: GetSocialCaptionsArgs): SocialCaptions => {
  return {
    twitter: () =>
      _t('Learn more about #{programName} from #{partnerName} on @Coursera.', {
        programName,
        partnerName,
      }),
    whatsapp: (shareLink) =>
      _t(
        'Did you know that you can earn #{programName} from #{partnerName} on Coursera? #{shareLink}. ' +
          'Coursera also offers online courses and Professional Certificates from 190+ world-class universities and companies, including Yale, the University of Pennsylvania, Google, IBM, and more.',
        {
          programName,
          partnerName,
          shareLink,
        }
      ),
    emailSubject: () =>
      _t('Earn a degree from #{partnerName} on Coursera', {
        partnerName,
      }),
    emailBody: (shareLink) =>
      _t(
        'Did you know that you can earn #{programName} from #{partnerName} on Coursera? #{shareLink}\n\n' +
          'Coursera also offers online courses and Professional Certificates from 190+ world-class universities and companies, including Yale, the University of Pennsylvania, Google, IBM, and more.\n\n' +
          'Let me know what you think!',
        {
          programName,
          partnerName,
          shareLink,
        }
      ),
  };
};
